import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store"
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {listBillLadingManageCod} from "@/modules/managecodcustomer/services";
import {ManageCodParams} from "@/modules/managecodcustomer/params";
import {getDataSequentially} from "@/shared/services/helper/utils";
import {listNotYetPayManageFee} from "@/modules/managefeecustomer/services";

@Module({ dynamic: true, name: "manageCodStore", store })
class ManageCodModule extends VuexModule {
    payedData: IdMapper<any> = {};
    payedIds: number[] = [];
    payedMeta: PaginationMeta = new PaginationMeta();
    payedParams: ManageCodParams = new ManageCodParams();
    payedDataExcel = [] as any;

    notPayData: IdMapper<any> = {};
    notPayIds: number[] = [];
    notPayMeta: PaginationMeta = new PaginationMeta();
    notPayParams: ManageCodParams = new ManageCodParams();
    notPayDataExcel = [] as any;

    @Mutation
    private MAP_PAYED_MANAGE_COD_LIST(payload: any) {
        const idMapper = {} as any;
        this.payedMeta = payload.meta;
        this.payedIds = payload.datas?.map((data: any, index: number) => {
            idMapper[data.rowGuid] = {...data, stt: index + 1};
            return data.rowGuid;
        });
        this.payedData = idMapper;
    }

    @Mutation
    private MAP_NOT_PAY_MANAGE_COD_LIST(payload: any) {
        const idMapper = {} as any;
        this.notPayMeta = payload.meta;
        this.notPayIds = payload.datas?.map((data: any, index: number) => {
            idMapper[data.rowGuid] = {...data, stt: index + 1};
            return data.rowGuid;
        });
        this.notPayData = idMapper;
    }

    @Mutation
    private UPDATE_PAYED_MANAGE_COD_PARAMS(payload: any) {
        this.payedParams = payload;
    }

    @Mutation
    private UPDATE_NOT_PAY_MANAGE_COD_PARAMS(payload: any) {
        this.notPayParams = payload;
    }

    @Mutation
    private UPDATE_NOT_PAY_COD_DATA_EXCEL(payload: any) {
        this.notPayDataExcel = payload;
    }

    @Mutation
    private UPDATE_PAYED_COD_DATA_EXCEL(payload: any) {
        this.payedDataExcel = payload;
    }

    @Action({ rawError: true })
    public async listPayedManageCod(params: any) {
        const { data } = await listBillLadingManageCod(params);
        this.MAP_PAYED_MANAGE_COD_LIST(data);
    }

    @Action({ rawError: true })
    public async listNotPayManageCod(params: any) {
        const { data } = await listBillLadingManageCod(params);
        this.MAP_NOT_PAY_MANAGE_COD_LIST(data);
    }

    @Action({ rawError: true })
    public updatePayedParams(payload: any) {
        this.UPDATE_PAYED_MANAGE_COD_PARAMS(payload);
    }

    @Action({ rawError: true })
    public async paramPayedManageCodChange(params: any) {
        this.updatePayedParams(params);
        await this.listPayedManageCod(params);
    }

    @Action({ rawError: true })
    public updateNotPayParams(payload: any) {
        this.UPDATE_NOT_PAY_MANAGE_COD_PARAMS(payload);
    }

    @Action({ rawError: true })
    public async paramNotPayManageCodChange(params: any) {
        this.updateNotPayParams(params);
        await this.listNotPayManageCod(params);
    }

    @Action({ rawError: true })
    public async exportExcelCodNotPay(params: any) {
        this.UPDATE_NOT_PAY_COD_DATA_EXCEL([]);
        const data = await getDataSequentially(listBillLadingManageCod, params);
        this.UPDATE_NOT_PAY_COD_DATA_EXCEL(data);
        return data;
    }

    @Action({ rawError: true })
    public async exportExcelCodPayed(params: any) {
        this.UPDATE_PAYED_COD_DATA_EXCEL([]);
        const data = await getDataSequentially(listBillLadingManageCod, params);
        this.UPDATE_PAYED_COD_DATA_EXCEL(data);
        return data;
    }
}

export const ManageCodStore = getModule(ManageCodModule);
